export enum FreegameStates
{
	Idle,
	IntroTransition,
	IntroMessage,
	NoPickIntro,

	// Pick,
	// RevealPicked,
	// RevealRemaining,

	// PickedMessage,

	WaitFirstSpin,
	//Running,
	Spin,
	FillingPot,
	Features,
	BigWin,
	Win,
	Bonus,
	Collect,
	SpinIdle,

	FinalMessage,
}